<!--轮播图管理-->


<template>
  <div class="image-container" v-loading="dataListLoading">
    <div class="tips">
      <span
        class="tips-text"
      >提示：图片大小不超过2MB，仅支持jpg、jpeg、gif、png，上传多张图片时，请尽量保证图片宽高尺寸一样，最多上传4张，最佳尺寸为1200 x 350像素</span>
      <el-button type="primary" @click="addOrUpdateHandle()">添加轮播图</el-button>
    </div>

    <div class="image-grid">
      <div class="image-item" v-for="(item,i) in imageList" :key="i">
        <el-form label-width="auto" label-position="left">
          <el-form-item label-width="0" style="display: flex;flex-flow: row-reverse">
            <el-button
              type="primary"
              class="iconBtn"
              icon="el-icon-edit"
              @click="addOrUpdateHandle(item.id)"
            ></el-button>
            <el-button
              type="danger"
              class="iconBtn"
              icon="el-icon-delete"
              @click="deleteHandle(item.id)"
            ></el-button>
          </el-form-item>

          <el-form-item label label-width="0">
            <el-image :src="$http.adornUrl(item.src)">
              <div slot="placeholder" class="image-slot">
                加载中
                <span class="dot">...</span>
              </div>
            </el-image>
          </el-form-item>

          <el-form-item label="链接">
            <el-input readonly :value="$http.adornUrl(item.src)"></el-input>
          </el-form-item>

          <el-form-item label="是否显示">
            <el-switch
              v-model="item.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="0"
              inactive-value="1"
              @change="onSwitchChange($event, item.id)"
            ></el-switch>
            <!--                <el-button type="primary">设置排序</el-button>-->
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-dialog
      title="添加轮播图"
      :visible.sync="addOrUpdateVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="addOrUpdateVisible = false"
      width="800px"
    >
      <add-or-update
        v-if="addOrUpdateVisible"
        :id="currentId"
        @close="addOrUpdateVisible = false"
        @refreshDataList="getDataList"
      ></add-or-update>
    </el-dialog>
  </div>
</template>


<script>
import AddOrUpdate from "./image-add-or-update";
export default {
  data() {
    return {
      dataForm: {
        key: ""
      },
      uploadAction: this.$http.adornUrl(
        `/fileupload/upload?token=${this.$cookie.get("token")}`
      ),
      imageList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      imageUrl: "",
      currentId: "",
    };
  },
  components: {
    AddOrUpdate
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    onSwitchChange(value, id) {
      this.$http({
        url: "updateImageById",
        method: "post",
        data: this.$http.adornData({
          id: id,
          status: value
        })
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message({
            message: "操作成功",
            type: "success",
            duration: 1500,
            onClose: () => {
              this.getDataList();
            }
          });
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http({
        url: "getImageByAccoungId",
        method: "get"
      }).then(({ data }) => {
        let { code, images } = data;
        if (code === 0) {
          this.imageList = images;
        } else {
          this.imageList = [];
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/login");
        }
        this.dataListLoading = false;
      }).catch(err => {
        this.$message.error("登录失效，请重新登录");
        this.$router.push("/login");
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.currentId = id;
      this.addOrUpdateVisible = true;
    },
    // 删除
    deleteHandle(id) {
      var ids = id
        ? [id]
        : this.dataListSelections.map(item => {
            return item.id;
          });
      this.$confirm(`确定删除当前轮播图？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl("/web/image/delete"),
          method: "post",
          data: this.$http.adornData(ids, false)
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.getDataList();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    }
  }
};
</script>

<style lang="scss">
.image-item {
  .el-upload,
  .el-icon-plus {
    width: 100% !important;
  }

  .el-form-item {
    margin-bottom: 10px;
  }
}
.el-message-box__btns button:nth-child(1) {
  &:hover {
    background-color: #ffffff;
    border-color: #dcdfe6;
    color: #606266;
  }
}
.el-message-box__btns button:nth-child(2) {
  background-color: #143372;
  border-color: #143372;
}
.image-container {
  .el-dialog {
    height: 620px;
    margin-top: 33vh;
    border: 1px solid #e5e5e5;
    .el-dialog__header {
      height: 48px;
      padding: 0;
      line-height: 48px;
      text-indent: 31px;
      font-size: 18px;
      .el-dialog__title {
        color: #143372;
      }
      border-bottom: 1px solid #e5e5e5;
    }
    .el-dialog__body {
      height: 502px;
      padding: 0;
      .catalogName {
        width: 520px;
        height: 42px;
        margin: 30px 0 0 29px;
      }
    }
  }
}
</style>


<style scoped lang="scss">
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-right: 30px;
}

.tips {
  width: 100%;
  height: 100px;
  padding-top: 10px;
  .tips-text {
    font-weight: 200;
    font-size: 12px;
    display: block;
    text-indent: 24px;
  }
  .el-button {
    width: 110px;
    height: 36px;
    background-color: #143372;
    border-color: #143372;
    font-size: 14px;
    line-height: 0;
    margin: 15px 20px 0 0;
    float: right;
  }
}
.iconBtn {
  height: 36px;
  background-color: #143372;
  border-color: #143372;
  font-size: 12px;
}

.image-grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .image-item {
    width: 350px;
    margin: 40px;
    box-shadow: 0px 1px 7px 4px rgba(0, 100, 214, 0.1);
    padding: 15px;
  }
}
.el-image {
  width: 350px;
  height: 215px;
}
</style>


